import * as React from 'react'
import { useTranslation } from '@/hooks/useTranslation'
import { cn } from '@/lib/utils'

const Footer = React.forwardRef<HTMLElement>(({ ...props }, ref) => {
	const { t } = useTranslation()
	return (
		<footer
			ref={ref}
			className={cn('flex justify-center items-center p-5 pb-[6rem] md:pb-5')}
			{...props}
		>
			<p className="text-sm text-center text-gray-600">{t('footer.copyright')}</p>
		</footer>
	)
})
Footer.displayName = 'Footer'

export { Footer }
